import React, { useState } from "react";
import { Accordion, Image } from "react-bootstrap";
import FilterIcon from "../images/filter.svg";
import ResetIcon from "../images/rotate-left.svg";
import BreadCrumbHeader from "../customcomponents/BreadCrumbHeader";
import TextInputWithLabel from "../customcomponents/TextInputWithLabel";
import { FaRegTimesCircle } from "react-icons/fa";
import DocumentIcon from "../images/document.svg";

const emptyFilters = () => ({
  dateFrom: "",
  dateTo: "",
  status: "",
  reference: "",
  amount: "",
  shipment: "",
  customer: "",
});

const InvoicesFilterSidebar = ({
  close,
  handleFilterFun,
  showCustomer = false,
  showCarrier = false,
}) => {
  const [filterObj, setFilterObj] = useState(emptyFilters());

  const setField = (key, value) => {
    setFilterObj((prev) => ({ ...prev, [key]: value }));
  };

  const submit = () => {
    handleFilterFun({ ...filterObj });
    close();
  };

  const reset = () => {
    setFilterObj(emptyFilters());
    handleFilterFun({});
    close();
  };

  return (
    <>
      <div className="overlay_back" onClick={close} />
      <aside className="sidebar">
        <FaRegTimesCircle
          onClick={close}
          size={25}
          className="crossIcon"
          color="#E10404"
        />

        <div className="siderfilter">
          <div onClick={submit} style={{ cursor: "pointer" }}>
            <Image src={FilterIcon} alt="" /> <strong>Filters</strong>
          </div>
          <div onClick={reset} style={{ cursor: "pointer" }}>
            <Image src={ResetIcon} alt="" /> Reset
          </div>
        </div>

        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <BreadCrumbHeader image={DocumentIcon} title="INVOICE FILTERS" />
            </Accordion.Header>
            <Accordion.Body>
              <TextInputWithLabel
                label="Date from"
                type="date"
                placeholder="DD/MM/YYYY"
                value={filterObj.dateFrom}
                onChange={(e) => setField("dateFrom", e.target.value)}
              />
              <TextInputWithLabel
                label="Date to"
                type="date"
                placeholder="DD/MM/YYYY"
                value={filterObj.dateTo}
                onChange={(e) => setField("dateTo", e.target.value)}
              />
              <TextInputWithLabel
                label="Status"
                type="text"
                placeholder="Pending, Paid, Overdue…"
                value={filterObj.status}
                onChange={(e) => setField("status", e.target.value)}
              />
              <TextInputWithLabel
                label="Reference"
                type="text"
                placeholder="Enter reference"
                value={filterObj.reference}
                onChange={(e) => setField("reference", e.target.value)}
              />
              <TextInputWithLabel
                label="Amount"
                type="text"
                placeholder="Enter amount"
                value={filterObj.amount}
                onChange={(e) => setField("amount", e.target.value)}
              />
              <TextInputWithLabel
                label="Shipment"
                type="text"
                placeholder="Enter shipment number"
                value={filterObj.shipment}
                onChange={(e) => setField("shipment", e.target.value)}
              />
              {showCustomer && (
                <TextInputWithLabel
                  label="Customer"
                  type="text"
                  placeholder="Enter customer"
                  value={filterObj.customer}
                  onChange={(e) => setField("customer", e.target.value)}
                />
              )}
              {showCarrier && (
                <TextInputWithLabel
                  label="Carrier"
                  type="text"
                  placeholder="Enter carrier"
                  value={filterObj.customer}
                  onChange={(e) => setField("customer", e.target.value)}
                />
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </aside>
    </>
  );
};

export default InvoicesFilterSidebar;
